import { render, staticRenderFns } from "./gb-whatsapp-pc.vue?vue&type=template&id=15f0065c&scoped=true"
import script from "./gb-whatsapp-pc.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-pc.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-pc.vue?vue&type=style&index=0&id=15f0065c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0065c",
  null
  
)

export default component.exports